import { isEmpty } from "lodash";
import { Redirect, Route, RouteProps, useParams, useLocation } from "react-router-dom";
import { useAppSelector } from "redux/configurations/reduxHooks";

export type ProtectedRouteProps = {
  isMicrosoftAuthenticated?: boolean;
} & RouteProps;

function PrivateRoute({
  children,
  isMicrosoftAuthenticated,
  ...rest
}: ProtectedRouteProps) {
  const token = useAppSelector(
    (state) => state.IdentityReducer.authenticate?.jwToken
  );
  const currentWarehouse = useAppSelector(
    (state) => state.IdentityReducer.currentWarehouse
  );
  const currentUser = useAppSelector(
    (state) => state.IdentityReducer.currentUser
  );
  const location = useLocation();
  const isAuthenticated =
    isMicrosoftAuthenticated ||
    (!isEmpty(token) && !isEmpty(currentWarehouse) && !isEmpty(currentUser));
  // console.log("isAuthenticated", isAuthenticated);
  // console.log("isMicrosoftAuthenticated", isMicrosoftAuthenticated);
  return isAuthenticated ? <Route {...rest} /> : <Redirect to={`/login${location.search || ''}`} />;
}

export default PrivateRoute;
